<template>
  <div class="body">
    <Header />
    <Video />
    <About id="about" />
    <Schedule />
    <Introduce />
    <Active id="active" />
    <Wander />
    <News id="news" />
    <Partner />
    <Ecology />
    <Media />
    <Review id="review" />
    <Footer />
    <Footers />
  </div>
</template>

<script setup>
import Ecology from './isc/ecology.vue'

import Header from '@/components/common/2023/header.vue'
import Video from './isc/video.vue'
import About from './isc/about.vue'
import Schedule from './isc/schedule.vue'
import Introduce from './isc/introduce.vue'
import Active from './isc/active.vue'
import Wander from '@/components/index/home/home-wander.vue'
import News from './isc/news.vue'
import Partner from './isc/partner.vue'
import Media from './isc/media.vue'
import Review from './isc/review.vue'
import Footer from './isc/footer.vue'
import Footers from '@/components/common/home-footer.vue'
import { watch } from 'vue'
import { useStore } from '@/store/2023/isc.js'
import { storeToRefs } from 'pinia'
const store = useStore()
const { pitchKey } = storeToRefs(store)
watch(pitchKey, () => {
  console.log('官网store:--', pitchKey)
})
</script>

<style lang="scss" scoped>
.body {
  overflow: hidden;
}
</style>
